import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'joinedPrograms');
export const actions = createActions(consts);
export const watcher = createReqWatcher(
  consts,
  actions,
  {
    endpoint: 'users',
    type: 'get',
    slug: [
      {
        type: 'payload',
        selector: ['id'],
      },
      'patient_programs',
      {
        type: 'payload.query',
        queryParameter: 'filter_by',
        selector: 'filterBy',
      },
    ],
  },
  true,
);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/joinedPrograms.js